import { render, staticRenderFns } from "./StateAnswerAccepted.vue?vue&type=template&id=51d8e399&scoped=true&lang=html&"
import script from "./StateAnswerAccepted.vue?vue&type=script&lang=coffee&"
export * from "./StateAnswerAccepted.vue?vue&type=script&lang=coffee&"
import style0 from "./StateAnswerAccepted.vue?vue&type=style&index=0&id=51d8e399&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d8e399",
  null
  
)

component.options.__file = "StateAnswerAccepted.vue"
export default component.exports